import { FeatureClientPlatform } from '@loamify/feature-flags';

export const LOAMIFY_CLIENT_HEADER = 'x-loamify-client';

let configuredClientApp: FeatureClientPlatform | null = null;

export function configureLoamifyApiClient(options: { clientApp: FeatureClientPlatform }) {
  configuredClientApp = options.clientApp;
}

export function resolveLoamifyClientAppHeader(): string | null {
  if (configuredClientApp) {
    return configuredClientApp;
  }

  const fromEnv = process.env.NEXT_PUBLIC_LOAMIFY_CLIENT_APP;
  if (fromEnv && Object.values(FeatureClientPlatform).includes(fromEnv as FeatureClientPlatform)) {
    return fromEnv;
  }

  return null;
}
